import { render, staticRenderFns } from "./journalReport.vue?vue&type=template&id=d6a88284&scoped=true&"
import script from "./journalReport.vue?vue&type=script&lang=js&"
export * from "./journalReport.vue?vue&type=script&lang=js&"
import style0 from "./journalReport.vue?vue&type=style&index=0&id=d6a88284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a88284",
  null
  
)

export default component.exports